import script from "./SceneDetail.vue?vue&type=script&lang=ts&setup=true&name=Poster"
export * from "./SceneDetail.vue?vue&type=script&lang=ts&setup=true&name=Poster"

import "./SceneDetail.vue?vue&type=style&index=0&id=31fe6a49&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31fe6a49"]])

export default __exports__